var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesktopRightCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 589,
    viewBox: "0 0 340 589",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.7386 595.252C35.2953 552.055 16.3264 507.329 14.5009 462.183C14.3622 458.651 14.293 455.118 14.293 451.59C14.293 369.125 49.8607 313.93 115.841 279.842C123.693 75.2271 227.086 0 400.927 0C581.873 0 770.557 118.013 770.557 342.097C770.557 342.641 770.547 343.185 770.547 343.729C814.402 379.742 840.97 424.448 840.97 477.57C840.97 522.815 827.879 569.455 793.024 613.924C841.064 648.448 865.95 684.47 868.103 720.879C868.251 723.417 868.32 725.956 868.32 728.494C868.32 842.776 711.142 857.05 471.365 857.05C231.583 857.05 -0.000427246 824.109 -0.000427246 709.826C-0.000427246 671.637 18.9832 632.056 71.7386 595.252Z",
    fill: "#AFC6DF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktopRightCloud);
export default __webpack_public_path__ + "static/media/desktop-right-cloud.a2be9dbe870539cf24b92b79eb69c367.svg";
export { ForwardRef as ReactComponent };